import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/loan1.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/loan2.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/loan3.webp");
;
import(/* webpackMode: "eager" */ "/app/public/svg/loan_arrow2.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/components/layouts/Banner/components/MobileBanner.tsx");
